(function(){
  var hrefs = [
    '/collections/assault',
    '/collections/ofertas-assault-fitness'
  ];
  function hide(){
    document.querySelectorAll('a[href]').forEach(function(a){
      var h = a.getAttribute('href') || '';
      if (h.indexOf('/collections/assault') !== -1 || h.indexOf('/collections/ofertas-assault-fitness') !== -1 || h.indexOf('/products/assault-') !== -1) {
        a.style.display = 'none';
        var p = a.parentElement;
        // climb a few levels for mega-menu columns / lis
        for (var i=0; i<4 && p; i++){
          if (p.matches && (p.matches('li') || /(^| )col-/.test(p.className||''))) {
            p.style.display = 'none';
            break;
          }
          p = p.parentElement;
        }
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hide);
  else hide();
  // Wokiee may rebuild menus
  setTimeout(hide, 500);
  setTimeout(hide, 1500);
})();